import {useEffect} from 'react'
import {DLMApplicationTerminateModalHeader} from './DLMApplicationTerminateModalHeader'
import { DLMApplicationTerminateModalForm } from './DLMApplicationTerminateModalForm'

type Props = {
  appID: number,
  siteID?: number
  onSuccess: Function
  onCancel: Function
}

const DLMApplicationTerminateModal = (props : Props) => {

    useEffect(() => {
        document.body.classList.add('modal-open')
        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [])

    return (
    <>
    <div
        className='modal fade show d-block'
        id='kt_modal_terminate_dlm_application'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
    >
        <div className='modal-dialog modal-dialog-centered mw-650px'>
            <div className='modal-content'>
                <DLMApplicationTerminateModalHeader />
                <div className='modal-body scroll-y mx-xl-10'>
                    <DLMApplicationTerminateModalForm { ...props} />
                </div>        
            </div>            
        </div>        
    </div>    
    <div className='modal-backdrop fade show'></div>    
    </>
    )
}

export {DLMApplicationTerminateModal}
